import React, { useEffect, useState } from 'react'
import useHttp from '../../../hook/use-http'
import ChartLoader_Orion from './ChartLoader_Orion'
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates'
import Table_Orion from './Table_Orion';

import './TopFiveSectionTemplate_Orion.css';

export default function TopFiveSectionTemplate_Orion(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;
  const [tableData, setTableData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let post_fix = "";

  if (IND == "RANGE") {
    post_fix = "Km";
  }

  const singleVinSelected = (vin) => {
    props.singleVinSelected(vin);
  }
  function compareObjects(object1, object2, key) {
    const obj1 = object1.value
    const obj2 = object2.value

    if (obj1 > obj2) {

      return -1
    }
    if (obj1 < obj2) {

      return 1
    }

    return 0
  }
  function compareObjectsAsc(object1, object2, key) {
    const obj1 = object1.value
    const obj2 = object2.value

    if (obj1 < obj2) {
      return -1
    }
    if (obj1 > obj2) {
      return 1
    }
    return 0
  }

  const appyDataAsc = (data) => {
    const res_result = data;
    let responce = [];
    if (res_result.length != 0) {
      let temp_result = res_result;
      if (template_id === "collapseOne") {
        temp_result.map(obj => {
          responce.push({ key: obj.key.vehicleId, value: (obj.median_Range.values["50.0"]) })
        })
      }
      else if (template_id === "collapseTwo") {
        temp_result.map(obj => {
          if (obj.median_NetkWh.values["50.0"] === null) { obj.median_NetkWh.values["50.0"] = 0.00 }
          responce.push({ key: obj.key.vehicleId, value: (obj.median_NetkWh.values["50.0"]) })
        })
      } else {
        temp_result.map(obj => {
          responce.push({ key: obj.key.vehicleId, value: (obj.distanceInKM.value) })
        })
      }
      responce.sort((value1, value2) => {
        return compareObjectsAsc(value1, value2, 'value')
      })
      setTableData((prestate) => responce);
    } else {
      setTableData((prestate) => []);
    }
  }
  const appyData = (data) => {
    const res_result = data;
    let responce = [];
    if (res_result.length != 0) {
      let temp_result = res_result;
      if (template_id === "collapseOne") {
        temp_result.map(obj => {
          responce.push({ key: obj.key.vehicleId, value: (obj.median_Range.values["50.0"]) })
        })
      }
      else if (template_id === "collapseTwo") {
        temp_result.map(obj => {
          if (obj.median_NetkWh.values["50.0"] === null) { obj.median_NetkWh.values["50.0"] = 0.00 }
          responce.push({ key: obj.key.vehicleId, value: (obj.median_NetkWh.values["50.0"]) })
        })
      } else {
        temp_result.map(obj => {
          responce.push({ key: obj.key.vehicleId, value: (obj.distanceInKM.value) })
        })
      }
      responce.sort((value1, value2) => {
        return compareObjects(value1, value2, 'value')
      })
      setTableData((prestate) => responce);
    } else {
      setTableData((prestate) => []);
    }
  }

  useEffect(() => {
    // fetchData({ url: API_URL_MAIN + "orion_drive_api/tabledata", body: { filterdata: gloablfilter, IND } }, appyData)
    fetchData({ url: API_URL_MAIN + "orion_drive_api/tabledata", body: { filterdata: gloablfilter, IND } }, appyData)
  }, [gloablfilter])

  const filterChnaged = (event) => {
    if (event.target.value === "asc")
      // fetchData({ url: API_URL_MAIN + "orion_drive_api/tabledata", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyDataAsc)
      fetchData({ url: API_URL_MAIN + "orion_drive_api/tabledata", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyDataAsc)
    else
      // fetchData({ url: API_URL_MAIN + "orion_drive_api/tabledata", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyData)
      fetchData({ url: API_URL_MAIN + "orion_drive_api/tabledata", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyData)
  }

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header" id={template_id + "Head"}>
          <div className="row for_gray_accordian">
            <div className="col-md-6 col-sm-6 col-6 col-6" style={{ padding: "0px" }}>
              <div className={`acc_line ${(soarting) ? "" : ""}`} style={{ fontSize: "0.43em" }} align="left" ><strong>&nbsp;{title}</strong></div>
            </div>
            <div className="col-md-4 col-sm-4 col-lg-4  col-4" style={{ padding: "0px" }}>
              {soarting && <select onChange={filterChnaged} className="form-select dropdownSelect acc_select" aria-label="Default select example">
                <option value="desc" >Top</option>
                <option value="asc">Bottom</option>
              </select>}
            </div>
            <div className="col-md-2 col-sm-2 col-lg-2 col-2" style={{ padding: "0px" }}>
              <button style={{ color: "#000" }} className="accordion-button accordion-button_bus acc_btn acc_btn_bus" type="button" data-bs-toggle="collapse" data-bs-target={"#" + template_id} aria-expanded="true" aria-controls="collapseOne">
              </button>
            </div>
          </div>
        </h2>

        <div id={template_id} className={`accordion-collapse collapse ${(show) ? "show" : ""}`} aria-labelledby={template_id + "Head"} data-bs-parent="#accordionExample">
          <div className="accordion-body p-2">
            {(isLoading) ? <ChartLoader_Orion /> : <Table_Orion data={tableData} singleVinSelected={singleVinSelected} post_fix={post_fix} />}
          </div>
        </div>
      </div>
    </>
  )
}
